import React, { useRef, useState } from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import ButtonBase from '@material-ui/core/ButtonBase';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: 16,
  },
  label: {
    ...theme.typography.body2,
    color: theme.palette.primary.main,
  },
  wrapper: {
    width: 330,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  container: {
    padding: '45px 30px 30px 30px',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    padding: 6,
  },
  intervalInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  intervalColor: {
    height: 12,
    width: 12,
    marginRight: 10,
    borderRadius: 6,
  },
  actualIntervalColor: {
    height: 14,
    width: 14,
    marginRight: 8,
    borderRadius: 7,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#FFFFFF',
  },
  intervalValues: {
    ...theme.typography.subtitle1,
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
  intervalLabel: {
    fontSize: '0.9rem',
    color: theme.palette.text.primary,
  },
}));

const GaugeAboutButtonWithModal = ({
  data,
  intervals,
  intervalIndex,
  track,
}) => {
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const classes = useStyles();

  if (!intervals) return null;

  const handleClick = () => {
    setOpen(!open);

    track('Assessment Results - Scoring Criteria Clicked');
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <ButtonBase
        disableRipple
        onClick={handleClick}
        className={classes.button}
        ref={anchorRef}
      >
        <Typography className={classes.label} gutterBottom>
          {_get(assessmentResultsSiteCopy, 'pageCopy.variantBScoreHelperLabel')}
        </Typography>
      </ButtonBase>
      <Modal open={!!open}>
        <Box className={classes.wrapper}>
          <ClickAwayListener onClickAway={handleClose}>
            <Paper className={classes.container}>
              <ButtonBase
                onClick={handleClose}
                className={classes.closeButton}
                aria-label="Close"
              >
                <CloseIcon />
              </ButtonBase>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6" color="textPrimary" gutterBottom>
                    {_get(
                      assessmentResultsSiteCopy,
                      'pageCopy.variantBScoreHeaderLabel',
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <RichTextReactRenderer
                    data={data}
                    component="p"
                    paragraphVariant="overline"
                  />
                </Grid>
                {intervals.map((interval, i) => (
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={4} className={classes.intervalInfoWrapper}>
                        <span
                          className={
                            i === intervalIndex
                              ? classes.actualIntervalColor
                              : classes.intervalColor
                          }
                          style={{
                            backgroundColor: interval.color,
                            boxShadow:
                              i === intervalIndex &&
                              `0 0 8px 0 ${interval.color}`,
                          }}
                        />
                        <Typography
                          className={classes.intervalValues}
                        >{`${interval.start}-${interval.end}`}</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className={classes.intervalLabel}>
                          {interval.label}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </ClickAwayListener>
        </Box>
      </Modal>
    </>
  );
};

export default GaugeAboutButtonWithModal;
